module.exports = __webpack_public_path__ + "static/media/top_selling_bg.dab244df.jpg";